// extracted by mini-css-extract-plugin
module.exports = {"metrics":"metrics_metrics__Hm4U2"};